// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"740":"cms-page","780":"website-cms-page","959":"static-page"}[chunkId] || chunkId) + "." + {"739":"8269c004","740":"54ba8231","780":"db4b5f22","959":"9b31d26d"}[chunkId] + ".chunk.js";
};